module.exports = __webpack_public_path__ + "static/img/bg_2.f05b16c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_2.png
// module id = pMXe
// module chunks = 1